import styled from 'styled-components';

export const DroppableItem = styled.div`
  height: 100%;
`;
